import { render, staticRenderFns } from "./BuyConfirmed.vue?vue&type=template&id=b7042d72&scoped=true&"
import script from "./BuyConfirmed.vue?vue&type=script&lang=js&"
export * from "./BuyConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./BuyConfirmed.vue?vue&type=style&index=0&id=b7042d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7042d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
